import { useQuery } from '@apollo/client';

import { useApiClient } from '@eluve/api-client-provider';
import { apiContract } from '@eluve/api-contract';

import { useAppointmentContext } from './appointment.context';
import { getAppointmentLatestSuperbillQuery } from './operations';

export const useLatestSuperbill = () => {
  const apiClient = useApiClient();
  const { appointmentId, tenantId } = useAppointmentContext();

  const { data, refetch } = useQuery(getAppointmentLatestSuperbillQuery, {
    variables: {
      tenantId,
      appointmentId,
    },
  });

  const superbill = data?.appointmentsByPk?.appointmentFiles?.[0];

  if (!superbill) {
    return { downloadUrl: null, refetch, superbill: null };
  }

  const downloadUrl = apiClient.getEndpointUrl(
    apiContract.appointments.downloadAppointmentFile,
    { appointmentId, tenantId, fileId: superbill.fileId },
  );

  return {
    downloadUrl,
    refetch,
    superbill,
  };
};
